module.exports = __webpack_public_path__ + "img/myopia_pic.abca5c84.png";